// MARK://dhk8/pos/lib/training-data
// The data sandbox behind "modo entrenamiento".
//
// In the no-backend preview build (`VITE_API_STUB=1` — the only build where the
// shell has real-looking data without a backend) every data client keeps its
// mutable state in module-level `let`s, seeded from `structuredClone(SEED_*)`.
// A trainee clicking through Floor → Order → Pay therefore mutates those module
// roots in place.
//
// `resetTrainingData()` re-clones the pristine seeds into every client's stub
// root. We call it on ENTERING training mode (so the trainee starts from a clean
// known state) and again on EXITING (so the trainee's edits vanish — they were
// never persisted anywhere, and the demo data is restored to pristine). That is
// the whole sandbox: the changes a trainee makes live only in module memory and
// are wiped on exit.
//
// Not a deep snapshot/restore (we don't preserve edits made *before* entering
// training); re-cloning the pristine seeds on both transitions is intentional —
// see lib/training-mode.ts and the P7 task notes.

import { __resetOrdersStub } from './clients/orders.js'
import { __resetFloorStub } from './clients/floor.js'
import { __resetCustomersStub } from './clients/customers.js'
import { __resetInvoicesStub } from './clients/invoices.js'
import { __resetStub as __resetKdsStub } from './clients/kds.js'

/** Re-clone the pristine seeds into every preview-stub client root. Idempotent. */
export function resetTrainingData(): void {
  __resetOrdersStub()
  __resetFloorStub()
  __resetCustomersStub()
  __resetInvoicesStub()
  __resetKdsStub()
}
